/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState } from 'react';
// material
import LabelAssignmentField from 'material/embeds/labelassignmentfield/labelassignmentfield_container'
import {Copy, Form, SubPage, Title, Divider, Accent} from "@insticator/insticator-ui";

// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/createlabels/editlabels_styles';




/* ========== ~~~~~~~~~~ CREATE LABELS ~~~~~~~~~~ ========== */
const CreateLabels = (props) => {
    const [labelUUIDs, setlabelUUIDs] = useState([]);


    const attachLabel = (labelUUID) => setlabelUUIDs([...labelUUIDs, labelUUID]);

    const removeLabel = (labelUUID) => setlabelUUIDs([...(labelUUIDs.filter(attachedLabelUUID => attachedLabelUUID !== labelUUID))])

    return(
        <SubPage name={`createlabels`} klass={props.classes.createlabels}>
            <Copy name={`title`}>
                <Title size={`medium`}>
                    <h2>{`Create Labels`}</h2>
                </Title>
            </Copy>
            <LabelAssignmentField attachedLabelUUIDs={labelUUIDs}
                                  attachLabel={attachLabel}
                                  removeLabel={removeLabel}
                                  blockSelect={true}
            />
            <Divider />
            <Accent>
                <span className={'accentitem'}>Create labels for your account</span>
                <span className={'accentitem'}>{`All changes will be applied instantly.`}</span>
            </Accent>
        </SubPage>);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(CreateLabels);
